var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFord(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 80,
    viewBox: "0 0 140 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 140,
    height: 80,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M112.805 38.7655C112.834 38.8516 112.834 38.909 112.834 38.9952C112.834 38.909 112.805 38.8516 112.805 38.7655ZM70 23.8655C46.0854 23.8655 26.9364 31.0428 26.9364 40C26.9364 48.9285 46.2576 56.1345 70 56.1345C93.7425 56.1345 113.064 48.8998 113.064 40C113.064 31.1002 93.7425 23.8655 70 23.8655Z",
    fill: "#D3D2D2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5967 40C27.5967 48.5553 46.5734 55.5029 70 55.5029C93.4266 55.5029 112.403 48.584 112.403 40C112.403 31.4447 93.4266 24.4971 70 24.4971C46.5734 24.4971 27.5967 31.4447 27.5967 40Z",
    fill: "url(#paint0_radial_212_360)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7834 40C30.7834 40.5742 30.8983 41.1484 31.128 41.7225C31.0418 41.3493 30.9844 40.9761 30.9844 40.6029C30.9844 33.5117 48.5257 27.7699 70.201 27.7699C90.1252 27.7699 106.575 32.6218 109.073 38.9378C107.408 32.306 90.5558 27.1096 70.0001 27.1096C48.3534 27.0809 30.7834 32.8801 30.7834 40Z",
    fill: "url(#paint1_linear_212_360)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M110.623 40C110.623 47.8089 92.4219 54.1536 70.0001 54.1536C50.0185 54.1536 33.4247 49.1295 30.0083 42.5264C32.6208 49.4166 49.6453 54.7278 70.2872 54.7278C92.7377 54.7278 110.911 48.4405 110.911 40.7177C110.911 39.9426 110.71 39.1675 110.365 38.421C110.537 38.9091 110.623 39.4545 110.623 40Z",
    fill: "url(#paint2_linear_212_360)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5792 41.378C76.6606 42.3254 76.6031 43.5599 77.206 44.1054C77.407 44.3063 77.6654 44.3925 77.9238 44.4212C77.5218 43.9331 77.3496 42.957 77.8376 42.2106C77.7515 41.9809 77.7228 41.7225 77.7802 41.4641C77.7802 41.4067 77.7515 41.3493 77.6941 41.3493C77.6367 41.3206 77.608 41.3493 77.5792 41.378Z",
    fill: "url(#paint3_linear_212_360)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M86.9671 43.3877C86.9671 43.5312 87.0245 43.7896 87.0532 43.9906C87.1106 43.9045 87.1393 43.8183 87.1968 43.7035C87.2255 43.6174 87.2255 43.6174 87.1681 43.5887C87.0819 43.56 86.9671 43.4738 86.9671 43.4164C86.9384 43.4164 86.9384 43.4164 86.9671 43.3877Z",
    fill: "url(#paint4_linear_212_360)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M88.0581 40.2871C88.3739 40.5742 88.5462 40.9187 88.5749 41.2632C88.5749 41.4068 88.7184 41.4355 88.8045 41.2919C88.8333 41.2632 88.862 41.2058 88.8907 41.1484C88.862 41.1197 88.8333 41.091 88.8045 41.0335C88.6897 40.89 88.3739 40.5742 88.0581 40.2871Z",
    fill: "url(#paint5_linear_212_360)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M75.4548 39.7129C75.6845 40.0574 75.7993 40.5167 75.7993 41.1196C75.7993 41.2632 75.9142 41.2632 75.9716 41.1483C76.0003 41.0909 76.0577 41.0335 76.0864 40.9761C75.9429 40.4306 75.6558 39.9139 75.4548 39.7129Z",
    fill: "url(#paint6_linear_212_360)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M83.8665 42.8709C83.0052 43.9044 82.5459 44.9666 82.5459 46.0002C82.5459 46.3734 82.6894 46.8327 83.0052 46.9763C83.1201 47.0337 83.2062 47.0624 83.321 47.0911C83.2923 46.9476 83.2636 46.804 83.2636 46.6892C83.2636 45.627 83.5794 44.5647 84.4407 43.5025C85.4742 42.2393 86.5652 41.6077 87.3116 41.9522C87.2829 41.6651 87.1394 41.4354 86.8236 41.2919C86.68 41.2345 86.5365 41.2057 86.3642 41.2057C85.6178 41.2057 84.6991 41.8373 83.8665 42.8709Z",
    fill: "url(#paint7_linear_212_360)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8133 40.6603C65.6649 41.0909 64.5166 41.78 63.7127 42.8422C62.794 44.048 62.5643 45.5121 63.1672 46.3734C63.3108 46.5744 63.483 46.7179 63.684 46.804C63.3682 45.7992 63.5979 44.4499 64.373 43.4164C65.1769 42.3541 66.0668 41.9522 67.0717 41.4929C67.2152 41.4354 67.2152 41.3493 67.1865 41.2345C67.1291 41.0335 67.0142 40.5168 66.9568 40.4019C66.9855 40.5455 66.9568 40.6316 66.8133 40.6603Z",
    fill: "url(#paint8_linear_212_360)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M75.426 43.9044L72.2967 48.7849C72.2393 48.8711 72.1819 48.8998 72.0958 48.9285H70C69.9139 48.9285 69.8852 48.8998 69.8564 48.8424L70.0287 49.6749C70.0574 49.7611 70.1148 49.7898 70.1722 49.7898H72.5551C72.6412 49.7898 72.7274 49.7323 72.7561 49.6462L75.7418 44.9666C75.9715 45.7418 76.0576 46.0863 76.4882 46.4595C76.8902 46.8327 77.2634 46.9189 77.8376 46.9189C78.3543 46.9189 78.8424 46.7179 79.4453 46.4595C79.675 46.3734 79.8472 46.2585 80.0195 46.1437C80.0195 45.8566 80.0482 45.5695 80.1056 45.3111C80.1056 45.2824 80.0769 45.1102 79.9333 45.1963C79.6462 45.3973 79.3017 45.5982 78.8424 45.7705C78.2969 45.9715 78.0385 46.0576 77.5218 46.0576C76.8902 46.0576 76.316 45.7705 75.9141 45.1389C75.6844 44.7944 75.5983 44.2776 75.5696 43.9044C75.5696 43.8757 75.5408 43.847 75.5121 43.847C75.4834 43.8757 75.4547 43.8757 75.426 43.9044Z",
    fill: "url(#paint9_linear_212_360)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M93.9147 44.7657C92.8812 46.0289 91.7615 47.206 90.6706 48.0385C88.9767 49.3591 87.3116 49.6749 86.479 48.8424C86.1632 48.5266 85.991 48.0959 85.991 47.694C85.991 47.4931 85.8761 47.4931 85.79 47.5792C84.7852 48.5553 83.0626 49.6462 81.4836 48.8711C80.7085 48.4692 80.2779 47.7514 80.1056 46.9476C80.1917 47.5218 80.3353 48.3543 80.5937 48.8711C80.7659 49.2156 81.1678 49.6175 81.4262 49.7324C82.833 50.4214 84.8139 49.6462 86.1058 48.4117C86.1058 48.383 86.1345 48.383 86.1345 48.383C86.1919 48.6127 86.2781 48.8711 86.2781 48.8998C86.3642 49.1869 86.5077 49.4453 86.6226 49.5888C87.5126 50.5936 89.3499 50.1343 91.3022 48.6414C92.3931 47.8089 93.197 46.9763 94.1731 45.8279C94.2018 45.7705 94.2018 45.7131 94.2018 45.5983L94.0008 44.6796C93.9434 44.6796 93.9434 44.737 93.9147 44.7657Z",
    fill: "url(#paint10_linear_212_360)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M80.565 41.2919C80.4789 41.9235 80.1344 42.469 79.5602 42.7561C79.0722 42.9858 78.498 42.9571 78.0961 42.5838C77.9812 42.469 77.8951 42.3255 77.809 42.1819C77.9238 42.6413 78.0099 42.9858 78.1248 43.1867C78.498 43.7609 79.1583 43.9045 79.876 43.5025C80.3928 43.2154 80.8521 42.6125 80.7947 41.6651C80.766 41.1771 80.6225 40.689 80.3928 40.2871C80.5625 40.5928 80.6232 40.9471 80.565 41.2919Z",
    fill: "url(#paint11_linear_212_360)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M95.2928 35.3778C94.977 35.952 88.661 45.5408 88.2591 46.5457C88.1442 46.8615 88.1155 47.0911 88.2591 47.2634C88.4026 47.4356 88.5749 47.4931 88.8045 47.4931C88.8332 47.3782 88.8619 47.2347 88.9194 47.0911C89.3213 46.0863 95.2354 37.1291 95.5512 36.5549C95.5799 36.4975 95.5799 36.4401 95.5512 36.4113C95.5225 36.3252 95.3215 35.3778 95.3215 35.2917C95.3215 35.3204 95.3215 35.3491 95.2928 35.3778Z",
    fill: "url(#paint12_linear_212_360)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1101 39.8564L69.1675 39.9139C69.5407 40.488 69.7417 41.2632 69.7704 42.0958C69.7991 42.268 69.8565 42.268 69.9427 42.1819C70.0288 42.0958 70.0862 42.0096 70.1723 41.9522C70.0575 41.5216 69.8853 41.1196 69.713 40.7464C69.6556 40.5742 69.3685 40.0861 69.1101 39.8564Z",
    fill: "url(#paint13_linear_212_360)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M72.3255 41.7513C70.9761 42.7848 69.8278 44.3925 69.2536 45.1102C68.9091 45.5409 68.5933 46.1438 67.7033 47.1199C66.2965 48.6415 64.4305 49.5314 62.6505 48.8998C61.6744 48.584 60.9567 47.7802 60.6983 46.8041C60.6409 46.6031 60.526 46.5744 60.4399 46.6892C60.1528 47.0625 59.5499 47.5792 59.0619 47.9237C59.0044 47.9524 58.8609 48.0386 58.7461 47.9811C58.6312 47.9237 58.2867 47.407 58.2006 47.2634C58.2006 47.2347 58.1719 47.2347 58.1719 47.206C58.2867 47.8376 58.3154 47.9237 58.4877 48.2108C58.6886 48.5266 58.8896 48.7563 58.9183 48.785C59.0331 48.8424 59.148 48.785 59.2054 48.7563C59.5786 48.5553 60.3251 47.9811 60.6696 47.5792C60.7557 47.4931 60.8705 47.5505 60.8992 47.6366C61.0428 48.0673 61.2437 48.3831 61.4447 48.7563C61.6744 49.1582 62.1624 49.5601 62.794 49.7324C63.5979 49.9621 64.4879 49.9908 65.6362 49.5601C66.5549 49.2156 67.531 48.4979 68.2775 47.6653C69.1675 46.6892 69.4833 46.0863 69.8278 45.6557C70.4019 44.938 71.3206 43.6748 72.5838 42.5838C73.0145 42.2106 73.5025 41.9522 73.8183 42.0671C73.9906 41.6077 73.9045 41.3493 73.7322 41.2058C73.6748 41.1771 73.5887 41.1484 73.5025 41.1484C73.158 41.2058 72.7274 41.4642 72.3255 41.7513Z",
    fill: "url(#paint14_linear_212_360)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7027 40.4593C48.9276 40.8613 48.0089 41.5216 47.5495 42.4403C47.1763 43.1867 47.1189 44.0767 47.6643 44.9379C47.7218 44.9954 47.7505 45.0815 47.8079 45.1389C47.6356 44.4212 47.8366 43.6747 48.095 43.1006C48.5543 42.1819 49.1859 41.7512 49.8175 41.3493C50.0759 41.1771 50.2195 41.0048 50.0472 40.5742C49.9898 40.4593 49.9611 40.2297 49.9324 40.0287C49.9611 40.2009 49.875 40.3732 49.7027 40.4593Z",
    fill: "url(#paint15_linear_212_360)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4732 31.3012C53.2626 32.1337 52.2865 33.885 52.7458 35.062C52.832 35.2917 52.9755 35.464 53.1765 35.5788C53.0329 34.4879 53.8368 32.7366 55.9613 32.0189C58.746 31.1002 61.8466 31.6744 64.3443 32.2198C64.6888 31.9902 65.0046 31.8466 65.2917 31.6744C65.4353 31.5882 65.263 31.5021 65.2343 31.5021C63.2534 31.1289 61.1863 30.6696 59.1767 30.6696C57.9135 30.6696 56.679 30.8418 55.4732 31.3012Z",
    fill: "url(#paint16_linear_212_360)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7463 37.8755C63.5371 37.9503 62.3306 38.0652 61.129 38.22C60.8706 38.2487 60.8419 38.3061 60.7845 38.3923C59.0907 41.177 57.3107 44.1628 55.3298 46.1724C53.2053 48.3256 51.454 48.8998 49.5879 48.8998C47.4348 48.9285 45.5112 47.694 45.0232 45.5408C45.2816 46.7466 46.0567 48.1821 46.9467 48.8137C47.8654 49.4453 48.7554 49.6749 49.7889 49.6749C51.9134 49.7036 53.8656 48.8424 55.9327 46.7466C57.9136 44.737 59.6361 41.9235 61.3013 39.1387C61.3587 39.0526 61.4161 38.9951 61.7032 38.9664C62.7654 38.8229 63.7128 38.7655 64.6602 38.6793C64.9473 38.6506 65.1483 38.6219 65.2631 38.7368C65.6076 39.0813 65.9808 39.3971 66.2679 39.5406C66.4402 39.5406 66.5837 39.5693 66.6986 39.6842C66.8134 39.6555 66.8995 39.598 66.9857 39.5406C67.1005 39.4258 67.1005 39.2822 67.1005 39.1674C67.0718 38.9377 66.9857 38.4784 66.9282 38.3635C66.9857 38.4497 66.9569 38.5932 66.8421 38.7081C66.756 38.7942 66.6411 38.8803 66.4976 38.8803C66.3828 38.8803 66.2966 38.8229 66.1531 38.7655C65.8373 38.5932 65.4354 38.3061 65.177 37.9903C65.1196 37.9042 65.0621 37.8755 64.9473 37.8755C64.8325 37.8468 64.8038 37.8755 64.7463 37.8755Z",
    fill: "url(#paint17_linear_212_360)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6168 39.5406C55.3871 39.7129 55.0426 39.6842 54.899 39.4545C54.8416 39.3684 54.8129 39.2823 54.8129 39.2248C54.7842 39.5981 54.9278 40.1148 55.0426 40.2871C55.1574 40.488 55.5306 40.5742 55.8177 40.3732C56.4493 39.8851 57.0522 39.6268 57.6838 39.4832L58.2293 38.7081C58.258 38.6794 58.258 38.6507 58.2293 38.6507C58.2293 38.6219 58.2006 38.6219 58.1432 38.6219C57.2532 38.6507 56.4206 38.9377 55.6168 39.5406Z",
    fill: "url(#paint18_linear_212_360)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4885 30.6982C82.4885 30.727 82.5172 30.727 82.5172 30.7557C82.5172 30.727 82.5172 30.6982 82.4885 30.6982Z",
    fill: "url(#paint19_linear_212_360)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6033 31.1002C82.5746 31.7031 82.0866 32.306 80.9095 32.9376C79.5602 33.684 78.1821 33.885 76.718 33.9137C73.1867 33.9424 69.8852 32.5644 66.4975 31.8179C66.4975 31.9615 66.5262 32.1337 66.4114 32.2486C64.5166 33.6553 62.8228 35.0621 61.6744 37.043C61.6457 37.1004 61.6457 37.1291 61.7318 37.1291C62.0476 37.1004 62.3347 37.1004 62.6218 37.0717C63.6553 35.4353 64.775 34.5166 66.4688 33.2534C66.5837 33.1673 66.7272 33.0811 66.6698 32.7366C70.0862 33.483 72.67 34.7463 77.0912 34.775C78.4118 34.775 80.2492 34.3443 81.254 33.7414C82.4024 33.0524 82.7182 32.5356 82.7469 32.0189C82.7469 31.8466 82.7182 31.5882 82.6895 31.4734C82.6607 31.3012 82.632 31.0715 82.5746 30.8992C82.6033 30.9279 82.6033 31.0141 82.6033 31.1002Z",
    fill: "url(#paint20_linear_212_360)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M66.153 35.263C66.1243 35.2917 66.0669 35.3491 66.0095 35.3778C65.665 35.7223 65.5788 36.1817 65.6075 36.5262C65.6363 36.6697 65.6937 36.6984 65.7511 36.6697C65.8085 36.6697 65.8946 36.641 65.9521 36.6123C65.9808 36.4114 66.0669 36.2391 66.2391 36.0668C66.3827 35.952 66.5549 35.8946 66.6985 35.9233C66.842 35.6649 66.8707 35.3491 66.6985 35.2056C66.6411 35.1482 66.555 35.1194 66.4401 35.1194C66.3827 35.1482 66.2679 35.1769 66.153 35.263Z",
    fill: "url(#paint21_linear_212_360)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5023 36.4688C67.1865 37.1004 66.6411 37.4162 66.1243 37.5884C66.1243 37.5884 66.0095 37.6171 66.0382 37.7033C66.0382 37.8181 66.4114 38.0478 66.6411 38.1913C66.6698 38.1913 66.7272 38.1626 66.7272 38.1626C66.9856 38.0478 67.4162 37.7894 67.6746 37.2439C67.8468 36.8994 67.933 36.6123 67.8469 35.9807C67.7894 35.5501 67.7033 35.1481 67.5885 34.9759C67.8469 35.4352 67.7607 36.0094 67.5023 36.4688Z",
    fill: "url(#paint22_linear_212_360)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0858 33.5692C58.1432 33.7127 58.1432 33.9711 58.0284 34.2582C57.081 36.4688 55.301 38.1913 53.1191 38.2774C51.7985 38.3062 50.8224 37.6458 50.363 36.6697C50.7075 37.4162 51.3966 38.0765 51.9995 38.4497C52.4588 38.7368 53.0617 38.909 53.722 38.8803C55.99 38.7942 57.7126 36.9281 58.2867 35.3491C58.4303 34.9185 58.3155 34.4591 58.258 34.172C58.2006 34.0285 58.1719 33.7701 58.0858 33.5692Z",
    fill: "url(#paint23_linear_212_360)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M112.805 38.7655C112.834 38.8516 112.834 38.909 112.834 38.9952C112.834 38.909 112.805 38.8516 112.805 38.7655ZM27.2235 40.201C27.2235 38.3062 28.0561 36.4401 29.8073 34.6601C35.9798 28.4302 52.1143 24.2387 69.9139 24.1526C93.5128 24.0664 112.719 31.1002 112.777 39.8277C112.777 41.7225 111.915 43.5599 110.164 45.3399C103.992 51.5698 87.8858 55.79 70.0862 55.8474C46.4873 55.9623 27.2809 48.9285 27.2235 40.201ZM70 23.8655C46.0854 23.8655 26.9364 31.0428 26.9364 40C26.9364 48.9285 46.2576 56.1345 70 56.1345C93.7425 56.1345 113.064 48.8998 113.064 40C113.064 31.1002 93.7425 23.8655 70 23.8655Z",
    fill: "#4F4C4D"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M27.08 40C27.08 40.4306 27.1374 40.8326 27.2235 41.2632C27.1661 40.9187 27.1087 40.5455 27.1087 40.201C27.1087 38.2775 27.9699 36.3539 29.7212 34.574C35.9224 28.3154 52.0856 24.0952 69.9139 24.0377C72.3829 24.0377 74.8232 24.0952 77.1773 24.2387C74.8519 24.0952 72.4403 24.009 70.0001 24.009C46.2002 24.009 27.08 31.1289 27.08 40Z",
    fill: "url(#paint24_linear_212_360)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M112.891 39.8277C112.891 41.7513 112.001 43.6461 110.221 45.426C104.049 51.6559 87.8858 55.9048 70.0575 55.991C67.5311 55.991 65.0621 55.9335 62.6505 55.79C65.0334 55.9335 67.4736 56.0197 69.9713 56.0197C93.6563 56.0197 112.891 48.785 112.891 40C112.891 39.6632 112.862 39.3271 112.805 38.9952C112.891 39.2823 112.891 39.5694 112.891 39.8277Z",
    fill: "url(#paint25_linear_212_360)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M29.348 40C29.348 47.8089 47.5496 54.1536 69.9714 54.1536C92.4219 54.1536 110.595 47.8089 110.595 40C110.623 32.1911 92.4506 25.8751 70.0001 25.8751C47.5496 25.8751 29.348 32.1911 29.348 40ZM30.7835 40C30.7835 32.8514 48.3247 27.0809 70.0001 27.0809C91.6468 27.0809 109.217 32.8514 109.217 40C109.217 47.1486 91.6755 52.9191 70.0001 52.9191C48.3534 52.9191 30.7835 47.1486 30.7835 40Z",
    fill: "url(#paint26_linear_212_360)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M92.996 35.2056C92.8238 35.2056 92.7664 35.2343 92.6802 35.3778C92.4219 35.8659 89.3787 40.4019 88.8332 41.2919C88.7471 41.4354 88.6323 41.4067 88.6036 41.2632C88.5461 40.7464 88.0868 40.1435 87.3691 39.8564C86.8236 39.6268 86.2781 39.5981 85.7326 39.6555C84.7278 39.799 83.8378 40.3158 83.0627 40.9187C81.8856 41.8087 80.8521 42.9857 79.5602 43.847C78.8425 44.3064 77.8664 44.737 77.206 44.1054C76.6032 43.5599 76.6893 42.3254 77.5793 41.378C77.6654 41.2919 77.7802 41.3493 77.7802 41.4641C77.6941 41.8948 77.8089 42.3254 78.1247 42.6125C78.5267 42.957 79.1008 43.0144 79.5889 42.7848C80.1631 42.4977 80.5076 41.9522 80.5937 41.3206C80.7373 40.3445 79.9908 39.5119 79.0721 39.4258C78.3257 39.3684 77.5793 39.6268 76.8902 40.2297C76.5457 40.5167 76.3448 40.7464 76.029 41.1771C75.9428 41.2919 75.828 41.2919 75.8567 41.1484C75.8854 39.9139 75.3687 39.2248 74.3638 39.1961C73.56 39.1674 72.7274 39.5981 72.0671 40.1435C71.3494 40.7177 70.7178 41.4929 70.0288 42.2106C69.9426 42.2967 69.8565 42.2967 69.8565 42.1245C69.8278 41.2919 69.6268 40.5167 69.2536 39.9426C69.1101 39.7416 68.823 39.6555 68.5933 39.7703C68.4785 39.8277 68.1053 40 67.8182 40.2297C67.6746 40.3445 67.6172 40.5167 67.6746 40.7177C68.0478 41.9522 67.9617 43.3302 67.4737 44.5073C67.0143 45.5983 66.1243 46.5457 65.0908 46.8902C64.4018 47.1198 63.6841 47.005 63.2534 46.4021C62.6505 45.5696 62.8802 44.1054 63.7989 42.8709C64.6027 41.8087 65.7511 41.1196 66.8995 40.689C67.043 40.6316 67.0717 40.5455 67.0143 40.4306C66.9569 40.2297 66.8421 39.9713 66.8133 39.8564C66.6985 39.5693 66.4114 39.5406 66.0382 39.5693C65.2056 39.6555 64.4592 39.9426 63.6841 40.3445C61.7318 41.378 60.7557 43.4164 60.3251 44.5073C60.1241 45.0241 59.9519 45.3399 59.7222 45.627C59.4064 46.0289 59.0332 46.3734 58.3155 46.9763C58.258 47.0337 58.2006 47.1486 58.258 47.2634C58.3442 47.4069 58.6887 47.9237 58.8035 47.9811C58.9183 48.0385 59.0619 47.9524 59.1193 47.9237C59.6074 47.5792 60.2103 47.0624 60.4973 46.6892C60.5835 46.5744 60.6983 46.6318 60.7557 46.804C61.0141 47.7802 61.7318 48.5553 62.7079 48.8998C64.4879 49.5027 66.354 48.6414 67.7607 47.1198C68.6507 46.1437 68.9665 45.5408 69.311 45.1102C69.8852 44.3925 71.0336 42.7848 72.3829 41.7512C72.871 41.378 73.4739 41.0909 73.761 41.2632C73.9906 41.4067 74.0767 41.7799 73.7035 42.469C72.3255 44.9954 70.2871 47.9811 69.9139 48.6988C69.8565 48.8137 69.9139 48.9285 70.0288 48.9285H72.1245C72.2394 48.9285 72.2968 48.8711 72.3255 48.785L75.4548 43.9044C75.5122 43.8183 75.5696 43.8757 75.5696 43.9331C75.5983 44.3064 75.6845 44.8231 75.9141 45.1676C76.3161 45.7992 76.8902 46.0576 77.5218 46.0863C78.0386 46.0863 78.297 46.0289 78.8425 45.7992C79.3018 45.627 79.6463 45.426 79.9334 45.225C80.1057 45.1102 80.1344 45.3112 80.1057 45.3399C79.8473 46.6605 80.1631 48.2395 81.4837 48.8711C83.0627 49.6462 84.7852 48.5553 85.7901 47.5792C85.8762 47.4931 85.991 47.4931 85.991 47.694C86.0197 48.0672 86.192 48.5266 86.4791 48.8424C87.3116 49.675 89.0055 49.3592 90.6706 48.0385C91.7616 47.206 92.8812 46.0289 93.9147 44.7657C93.9434 44.7083 93.9722 44.6509 93.9147 44.5647C93.7712 44.3925 93.5415 44.2202 93.3693 44.0767C93.3118 44.0193 93.197 44.048 93.1396 44.0767C92.0774 45.0815 91.1587 46.2012 89.7806 47.1486C89.3213 47.4644 88.5748 47.7227 88.259 47.2921C88.1442 47.1198 88.1442 46.8902 88.259 46.5744C88.661 45.5696 94.977 35.9807 95.2928 35.4065C95.3502 35.3204 95.2928 35.2343 95.1779 35.2343C94.5176 35.2056 93.6564 35.2056 92.996 35.2056ZM83.0053 47.005C82.6895 46.8328 82.5459 46.3734 82.5459 46.0289C82.5746 44.9954 83.034 43.9331 83.8666 42.8996C84.9001 41.6364 86.0484 40.9761 86.7949 41.3206C87.57 41.6938 87.3116 42.5838 86.9671 43.3015C86.9384 43.359 86.9384 43.4164 86.9671 43.4451C86.9671 43.5312 87.082 43.5886 87.1681 43.6173C87.1968 43.6173 87.2255 43.646 87.1968 43.7322C86.9384 44.3064 86.68 44.6509 86.3355 45.1389C86.0197 45.5983 85.6752 45.9715 85.2446 46.316C84.7565 46.7179 84.1249 47.1486 83.522 47.1486C83.3498 47.1486 83.1488 47.0911 83.0053 47.005Z",
    fill: "url(#paint27_linear_212_360)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4638 29.3776L57.6552 29.4638C53.7794 29.7796 50.1047 31.9614 50.076 35.2917C50.076 36.9855 51.2818 38.3349 53.1191 38.2774C55.301 38.1913 57.081 36.4688 58.0284 34.2582C58.3729 33.4256 57.7126 33.0811 57.4255 33.5692C56.88 34.4304 56.0762 35.0907 55.2436 35.5214C54.2101 36.0094 53.1191 35.8946 52.8033 35.062C52.344 33.885 53.3201 32.1337 55.5307 31.3011C58.7174 30.1241 62.0764 30.8992 65.2918 31.5021C65.3492 31.5021 65.5215 31.5882 65.3492 31.6744C64.775 31.9902 64.2008 32.2485 63.3109 32.995C62.6793 33.5404 61.8467 34.2582 61.2151 35.0333C60.5835 35.8085 60.1242 36.4975 59.5213 37.2726C59.4351 37.3875 59.349 37.3875 59.349 37.3875C57.8848 37.6458 56.4781 37.7894 55.1575 38.7081C54.8991 38.8803 54.7843 39.2248 54.9278 39.4832C55.0714 39.7129 55.4159 39.7416 55.6455 39.5694C56.4494 38.9665 57.282 38.6794 58.2581 38.6507C58.2868 38.6507 58.3155 38.6507 58.3442 38.6794V38.7368C56.9087 40.7177 56.5642 41.1771 55.4733 42.4116C54.9278 43.0432 54.3823 43.5886 53.7794 44.1341C51.3392 46.4021 48.6979 46.3734 47.7505 44.938C47.1764 44.0767 47.2625 43.1867 47.6357 42.4403C48.095 41.5216 49.0137 40.8613 49.7889 40.4593C50.076 40.3158 50.1621 39.9426 49.875 39.6268C49.7028 39.3971 49.2434 39.3684 48.9276 39.4258C47.9228 39.5981 46.7457 40.3732 46.028 41.2919C45.2528 42.3254 44.8509 43.5599 44.9658 44.938C45.1954 47.4644 47.2625 48.8998 49.6166 48.8998C51.4827 48.8711 53.2627 48.3256 55.3584 46.1724C57.3394 44.1628 59.148 41.1771 60.8132 38.3923C60.8706 38.3062 60.8993 38.2487 61.1577 38.22C62.3593 38.0652 63.5658 37.9503 64.775 37.8755C65.0047 37.8755 65.0334 37.8755 65.1195 37.9904C65.3779 38.3062 65.7799 38.5932 66.0957 38.7655C66.2392 38.8516 66.3253 38.8803 66.4402 38.8803C66.5837 38.8803 66.6985 38.7942 66.7847 38.7081C66.8995 38.5932 66.9282 38.4497 66.8708 38.3349C66.8134 38.22 66.1244 37.8468 66.0957 37.7033C66.0669 37.6171 66.1818 37.5884 66.1818 37.5884C66.6985 37.4162 67.2153 37.1004 67.5598 36.4688C67.8756 35.8659 67.933 35.0333 67.3589 34.6027C66.8421 34.2008 66.0669 34.2582 65.4641 34.8324C64.8612 35.3778 64.6602 36.153 64.7463 36.842C64.7463 36.9568 64.7463 37.0142 64.6028 37.0142C63.6841 37.1004 62.7941 37.1004 61.7893 37.1578C61.7319 37.1578 61.7032 37.1291 61.7319 37.0717C62.8802 35.0907 64.5741 33.684 66.4689 32.2772C66.5837 32.1911 66.555 32.0189 66.555 31.8466C69.9714 32.593 73.2442 33.9711 76.7754 33.9424C78.2396 33.9424 79.6463 33.7127 80.967 32.9663C82.144 32.3347 82.6321 31.7318 82.6608 31.1289C82.6895 30.6982 82.4024 30.4399 81.9718 30.526C78.4119 31.3586 74.9955 31.3298 71.4355 30.8992C67.3589 30.3824 63.4831 29.3776 59.4638 29.3776ZM65.6076 36.5262C65.5502 36.153 65.665 35.6362 66.0957 35.2917C66.2966 35.1194 66.5837 35.062 66.7273 35.2056C66.9282 35.3778 66.8134 35.7798 66.6411 36.0381C66.4402 36.3539 66.0669 36.6123 65.7511 36.6697H65.7224C65.6937 36.6984 65.6363 36.6697 65.6076 36.5262Z",
    fill: "url(#paint28_linear_212_360)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_212_360",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(69.6268 202.036) scale(185.936 181.307)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00050D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#051125"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.905,
    stopColor: "#173E7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.955,
    stopColor: "#4CA9E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4CA9E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_212_360",
    x1: 69.9283,
    y1: 56.5163,
    x2: 69.9283,
    y2: 23.6961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08142E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.809,
    stopColor: "#17326E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D69A9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_212_360",
    x1: 70.4594,
    y1: 56.5192,
    x2: 70.4594,
    y2: 23.6961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08142E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.809,
    stopColor: "#17326E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D69A9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_212_360",
    x1: 77.355,
    y1: 50.8733,
    x2: 77.355,
    y2: 28.1328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08142E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.809,
    stopColor: "#17326E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D69A9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_212_360",
    x1: 87.0696,
    y1: 50.9718,
    x2: 87.0696,
    y2: 27.9281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08142E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.809,
    stopColor: "#17326E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D69A9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_212_360",
    x1: 88.4893,
    y1: 50.0712,
    x2: 88.4893,
    y2: 28.9619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08142E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.809,
    stopColor: "#17326E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D69A9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_212_360",
    x1: 75.7856,
    y1: 50.3752,
    x2: 75.7856,
    y2: 28.5551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08142E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.809,
    stopColor: "#17326E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D69A9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_212_360",
    x1: 84.9135,
    y1: 50.9617,
    x2: 84.9135,
    y2: 27.9551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08142E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.809,
    stopColor: "#17326E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D69A9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_212_360",
    x1: 65.0121,
    y1: 50.9433,
    x2: 65.0121,
    y2: 27.9419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08142E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.809,
    stopColor: "#17326E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D69A9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_212_360",
    x1: 74.9543,
    y1: 50.9467,
    x2: 74.9543,
    y2: 28.1023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08142E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.809,
    stopColor: "#17326E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D69A9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_212_360",
    x1: 87.1141,
    y1: 50.9542,
    x2: 87.1141,
    y2: 27.9424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08142E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.809,
    stopColor: "#17326E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D69A9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_212_360",
    x1: 79.313,
    y1: 50.9655,
    x2: 79.313,
    y2: 27.9393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08142E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.809,
    stopColor: "#17326E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D69A9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_212_360",
    x1: 91.8689,
    y1: 50.9439,
    x2: 91.8689,
    y2: 27.9379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08142E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.809,
    stopColor: "#17326E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D69A9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_212_360",
    x1: 69.6424,
    y1: 50.7059,
    x2: 69.6424,
    y2: 28.231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08142E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.809,
    stopColor: "#17326E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D69A9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_212_360",
    x1: 66.0531,
    y1: 50.9468,
    x2: 66.0531,
    y2: 28.0955,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08142E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.809,
    stopColor: "#17326E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D69A9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_212_360",
    x1: 48.7071,
    y1: 50.9436,
    x2: 48.7071,
    y2: 27.9384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08142E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.809,
    stopColor: "#17326E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D69A9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_212_360",
    x1: 58.9967,
    y1: 50.9543,
    x2: 58.9967,
    y2: 27.954,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08142E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.809,
    stopColor: "#17326E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D69A9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_212_360",
    x1: 56.0024,
    y1: 50.9485,
    x2: 56.0024,
    y2: 27.9424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08142E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.809,
    stopColor: "#17326E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D69A9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_212_360",
    x1: 56.5438,
    y1: 50.9626,
    x2: 56.5438,
    y2: 27.9453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08142E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.809,
    stopColor: "#17326E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D69A9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_212_360",
    x1: 82.5124,
    y1: 50.5245,
    x2: 82.5124,
    y2: 28.0076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08142E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.809,
    stopColor: "#17326E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D69A9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_212_360",
    x1: 72.2058,
    y1: 50.9462,
    x2: 72.2058,
    y2: 27.9428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08142E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.809,
    stopColor: "#17326E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D69A9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_212_360",
    x1: 66.232,
    y1: 50.1653,
    x2: 66.232,
    y2: 28.4325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08142E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.809,
    stopColor: "#17326E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D69A9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_212_360",
    x1: 66.9681,
    y1: 50.9531,
    x2: 66.9681,
    y2: 27.947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08142E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.809,
    stopColor: "#17326E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D69A9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_212_360",
    x1: 54.3582,
    y1: 50.9542,
    x2: 54.3582,
    y2: 27.9476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08142E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.809,
    stopColor: "#17326E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D69A9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_212_360",
    x1: 60.5373,
    y1: 63.8791,
    x2: 50.5873,
    y2: 26.7456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2B1B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#DEDDDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#DEDDDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B2B1B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_212_360",
    x1: 86.7222,
    y1: 43.5372,
    x2: 76.8185,
    y2: 6.57572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2B1B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#DEDDDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#DEDDDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B2B1B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_212_360",
    x1: 69.9998,
    y1: 23.4756,
    x2: 69.9998,
    y2: 56.465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.552,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.691,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#D3D2D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDBCBC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_212_360",
    x1: 76.7481,
    y1: 34.0259,
    x2: 76.7481,
    y2: 50.3867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.552,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.691,
    stopColor: "#EFEEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3D2D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_212_360",
    x1: 63.7277,
    y1: 27.8018,
    x2: 63.7277,
    y2: 50.4972,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.552,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.691,
    stopColor: "#EFEEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3D2D2"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFord);
export default __webpack_public_path__ + "static/media/Ford.236b3f1b11063f5f7191bca9316fcc62.svg";
export { ForwardRef as ReactComponent };